export enum OperationState {
  NotSet,
  Idle,
  Processing,
  Complete,
  Error,
}
